import { createSlice } from "@reduxjs/toolkit";
import { setInitialState } from "../../../store/InitialState";

const INITIAL_STATE = setInitialState({
    data: null,
    isFetching: false,
    isSuccess: false,
    isError: false,
    error: null,
});

const validateMFACodeSlice = createSlice({
    name: "validateMFACodeSlice",
    initialState: INITIAL_STATE,
    reducers: {
        validateMFACodeRequest: (state) => {
            state.isFetching = true;
        },
        validateMFACodeSuccess: (state, action) => {
            state.isFetching = false;
            state.isSuccess = true;
            state.data = action.payload;
        },
        validateMFACodeFailure: (state, action) => {
            state.isFetching = false;
            state.isSuccess = false;
            state.isError = true;
            state.error = action.payload;
        },
        resetValidateMFACode: (state) => {
            state.data = null;
            state.error = null;
            state.isError = false;
            state.isFetching = false;
            state.isSuccess = false;
        },
    },
});

// Exporting actions for saga and views
export const {
    validateMFACodeRequest,
    validateMFACodeSuccess,
    validateMFACodeFailure,
    resetValidateMFACode,
} = validateMFACodeSlice.actions;

export default validateMFACodeSlice.reducer;
